import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useContext } from 'react';
import { Context } from '../..';
// import UserService from '../../services/UserService';
import { DocsSettingsModal } from './modal/DocsSettingsModal';
import { EventSettingsModal } from './modal/EventSettingsModal';
import { FeedbackListModal } from './modal/FeedbackListModal';
import { OrganizationsListModal } from './modal/OrganizationsListModal';
import { QuestionsListModal } from './modal/QuestionsListModal';
import { RecommendationsOfSpecsModal } from './modal/RecommendationsOfSpecsModal';
import { SpecActiveModal } from './modal/SpecActiveModal';
import { SpecializationsListModal } from './modal/SpecializationsListModal';
import { SpecInfoFullModal } from './modal/SpecInfoDataModal';
import { UsersModal } from './modal/UsersModal';
import { VideoSettingsModal } from './modal/VideoSettingsModal';
import { VideoModerateModal } from './modal/VideoModerateModal';

const SettingsForSpecialists: FC = () => {
    const { store } = useContext(Context);

    const [eventModal, setEventModal] = useState<boolean>(false);
    const [docsModal, setDocsModal] = useState<boolean>(false);
    const [recsModal, setRecsModal] = useState<boolean>(false);
    const [usersModal, setUsersModal] = useState<boolean>(false);
    const [specInfoModal, setSpecInfoModal] = useState<boolean>(false);
    const [organizationsListModal, setOrganizationsListModal] = useState<boolean>(false);
    const [specializationsListModal, setSpecializationsListModal] = useState<boolean>(false);
    const [specActiveModal, setSpecActiveModal] = useState<boolean>(false);
    const [questionsListModal, setQuestionsListModal] = useState<boolean>(false);
    const [feedbackListModal, setFeedbackListModal] = useState<boolean>(false);
    const [videoAddModal, setVideoAddModal] = useState<boolean>(false);
    const [videoModerateModal, setVideoModerateModal] = useState<boolean>(false);

    // const getMoodleUrl = async () => {
    //     const mu = await UserService.goToMoodle({fio: store.specInfo?.fio || ' ', status: 'участник'})
    //     const url = mu.data
    //     console.log(url)
    //     window.open(url, '_blank')
    // };

    return (
        <div className='row m-3'>
            <div className="col-sm-3" onClick={() => setEventModal(true)}>
                <div className="card m-3">
                    <div className="card-header bg-success">
                        <h5 className="card-title text-light"><Trans>Events settings</Trans></h5>
                    </div>
                    <div className="card-body">
                        <p className="card-text rounded"><Trans>Click to set up the event page</Trans></p>
                    </div>
                </div>
            </div>

            <div className="col-sm-3" onClick={() => setDocsModal(true)}>
                <div className="card m-3 ">
                    <div className="card-header bg-success">
                        <h5 className="card-title text-light"><Trans>Working with files</Trans></h5>
                    </div>
                    <div className="card-body">
                        <p className="card-text rounded"><Trans>Click to add/remove files</Trans></p>
                    </div>
                </div>
            </div>

            <div className="col-sm-3" onClick={() => setRecsModal(true)}>
                <div className="card m-3">
                    <div className="card-header bg-success">
                        <h5 className="card-title text-light"><Trans>Recommendations</Trans></h5>
                    </div>
                    <div className="card-body">
                        <p className="card-text rounded"><Trans>Click to edit recommendations</Trans></p>
                    </div>
                </div>
            </div>

            <div className="col-sm-3" onClick={() => setVideoAddModal(true)}>
                <div className="card m-3">
                    <div className="card-header bg-success">
                        <h5 className="card-title text-light"><Trans>Video</Trans></h5>
                    </div>
                    <div className="card-body">
                        <p className="card-text rounded"><Trans>Click to add videos for the page 'Proud of you, our graduate!'</Trans></p>
                    </div>
                </div>
            </div>

            {store.user.is_superuser ?
                <div className="col-sm-3" onClick={() => setUsersModal(true)}>
                    <div className="card m-3">
                        <div className="card-header bg-success">
                            <h5 className="card-title text-light"><Trans>List of users</Trans></h5>
                        </div>
                        <div className="card-body">
                            <p className="card-text rounded"><Trans>Click to work with users</Trans></p>
                        </div>
                    </div>
                </div>
                : null}

            {store.user.is_superuser ?
                <div className="col-sm-3" onClick={() => setSpecInfoModal(true)}>
                    <div className="card m-3">
                        <div className="card-header bg-success">
                            <h5 className="card-title text-light"><Trans>List of specialists</Trans></h5>
                        </div>
                        <div className="card-body">
                            <p className="card-text rounded"><Trans>Click to see the specialists</Trans></p>
                        </div>
                    </div>
                </div>
                : null}

            {store.user.is_superuser ?
                <div className="col-sm-3" onClick={() => setOrganizationsListModal(true)}>
                    <div className="card m-3">
                        <div className="card-header bg-success">
                            <h5 className="card-title text-light"><Trans>List of organizations</Trans></h5>
                        </div>
                        <div className="card-body">
                            <p className="card-text rounded"><Trans>Click to see the organizations</Trans></p>
                        </div>
                    </div>
                </div>
                : null}

            {store.user.is_superuser ?
                <div className="col-sm-3" onClick={() => setSpecializationsListModal(true)}>
                    <div className="card m-3">
                        <div className="card-header bg-success">
                            <h5 className="card-title text-light"><Trans>List of specializations</Trans></h5>
                        </div>
                        <div className="card-body">
                            <p className="card-text rounded"><Trans>Click to see the specializations</Trans></p>
                        </div>
                    </div>
                </div>
                : null}

            {store.user.is_superuser ?
                <div className="col-sm-3" onClick={() => setSpecActiveModal(true)}>
                    <div className="card m-3">
                        <div className="card-header bg-success">
                            <h5 className="card-title text-light"><Trans>Activity of specialists</Trans></h5>
                        </div>
                        <div className="card-body">
                            <p className="card-text rounded"><Trans>Click to see the activity of specialists</Trans></p>
                        </div>
                    </div>
                </div>
                : null}

            {store.user.is_superuser ?
                <div className="col-sm-3" onClick={() => setQuestionsListModal(true)}>
                    <div className="card m-3">
                        <div className="card-header bg-success">
                            <h5 className="card-title text-light"><Trans>All questions</Trans></h5>
                        </div>
                        <div className="card-body">
                            <p className="card-text rounded"><Trans>Click to see the all questions</Trans></p>
                        </div>
                    </div>
                </div>
                : null}

            {store.user.is_superuser ?
                <div className="col-sm-3" onClick={() => setFeedbackListModal(true)}>
                    <div className="card m-3">
                        <div className="card-header bg-success">
                            <h5 className="card-title text-light"><Trans>Feedbacks</Trans></h5>
                        </div>
                        <div className="card-body">
                            <p className="card-text rounded"><Trans>Click to see the all feedbacks</Trans></p>
                        </div>
                    </div>
                </div>
                : null}

            {store.user.is_superuser ?
                <div className="col-sm-3" onClick={() => setVideoModerateModal(true)}>
                    <div className="card m-3">
                        <div className="card-header bg-success">
                            <h5 className="card-title text-light"><Trans>Moderate videos</Trans></h5>
                        </div>
                        <div className="card-body">
                            <p className="card-text rounded"><Trans>Click to see the all videos and moderate them</Trans></p>
                        </div>
                    </div>
                </div>
                : null}

            {/* {store.user.is_superuser ?
                <div className="col-sm-3" onClick={() => getMoodleUrl()}>
                    <div className="card m-3">
                        <div className="card-header bg-success">
                            <h5 className="card-title text-light"><Trans>Moodle</Trans></h5>
                        </div>
                        <div className="card-body">
                            <p className="card-text rounded"><Trans>Click to go to moodle</Trans></p>
                        </div>
                    </div>
                </div>
                : null} */}

            <EventSettingsModal toggle={eventModal} setToggle={setEventModal} />
            <DocsSettingsModal toggle={docsModal} setToggle={setDocsModal} />
            <RecommendationsOfSpecsModal toggle={recsModal} setToggle={setRecsModal} />
            <VideoSettingsModal toggle={videoAddModal} setToggle={setVideoAddModal} />
            <UsersModal toggle={usersModal} setToggle={setUsersModal} />
            <SpecInfoFullModal toggle={specInfoModal} setToggle={setSpecInfoModal} />
            <OrganizationsListModal toggle={organizationsListModal} setToggle={setOrganizationsListModal} />
            <SpecializationsListModal toggle={specializationsListModal} setToggle={setSpecializationsListModal} />
            <SpecActiveModal toggle={specActiveModal} setToggle={setSpecActiveModal} />
            <QuestionsListModal toggle={questionsListModal} setToggle={setQuestionsListModal} />
            <FeedbackListModal toggle={feedbackListModal} setToggle={setFeedbackListModal} />
            <VideoModerateModal toggle={videoModerateModal} setToggle={setVideoModerateModal} />
        </div>
    )
};
export default observer(SettingsForSpecialists);